import { STATUS } from "@shared/constants";
import { produce } from "immer";
import { ActionType, createReducer } from "typesafe-actions";

import { UserStateType } from "../interfaces";
import * as actions from "./actions";

type Action = ActionType<typeof actions>;

const defaultFilter = {
  page: 0,
  limit: 50,
  search: "",
  status: STATUS.ACTIVE,
};

export const initialState: UserStateType = {
  users: [],
  usersTotal: 0,
  filter: { ...defaultFilter },
  currentUserSession: null,
};

const reducer = createReducer<UserStateType, Action>(initialState)
  .handleAction(actions.getUsers.success, (state, action) =>
    produce(state, (nextState) => {
      const { rows, count, is_clear } = action.payload;
      nextState.users = !is_clear ? [...nextState.users, ...rows] : [...rows];
      nextState.usersTotal = count;
    }),
  )
  .handleAction(actions.setFilter, (state, action) =>
    produce(state, (nextState) => {
      nextState.filter = action.payload || { ...defaultFilter };
    }),
  )
  .handleAction(actions.clearUsers, (state) =>
    produce(state, (nextState) => {
      nextState.users = [];
      nextState.usersTotal = 0;
    }),
  )
  .handleAction(actions.createUser.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.users = [action.payload.user, ...nextState.users];
    }),
  )
  .handleAction(actions.updateUser.success, (state, action) =>
    produce(state, (nextState) => {
      const users = nextState.users;

      const foundUserIndex = users.findIndex((u) => action.payload.user.id === u.id);
      users[foundUserIndex] = action.payload.user;

      nextState.users = [...users];
    }),
  )
  .handleAction(actions.createUserSession.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.currentUserSession = action.payload.user_session;
    }),
  )
  .handleAction(actions.updateUserSession.success, (state, action) =>
    produce(state, (nextState) => {
      nextState.currentUserSession = action.payload.user_session;
    }),
  )
  .handleAction(actions.updateUserStatus.success, (state, action) =>
    produce(state, (nextState) => {
      const users = nextState.users;

      const foundUserIndex = users.findIndex((u) => action.payload.user.id === u.id);
      users[foundUserIndex] = action.payload.user;

      nextState.users = [...users];
    }),
  );

export { reducer as UserReducer };
